module.exports = {
    defaultLanguage: 'es',
    profileColor: {saturation: 70, brightness: 100},
    scssVariables: './src/styles/n32024',
    defaultPassword: 'default'
}